module.exports = __webpack_public_path__ + "img/icon-run-black.b1bc7231.svg";